const prefix = 'mediavine-video__'

export const SECURE = false // process.env.ENV !== 'development'

export const PLAYLIST_POSITION = `${prefix}playlist-position`
export const PLAYLIST_POSITION_EXPIRES = 0.01 // ~15 minutes

export const AUTOPLAY_DISABLED = `${prefix}autoplay-disabled`
export const AUTOPLAY_DISABLED_EXPIRES = 0.042 // ~1 hour
